import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { onboardingApi } from '../../utils/onboardingApi';

const GetStartedContext = createContext(null);

// The one place that fetches GET /api/onboarding (its "all set" answer comes
// only once), shared by the checklist and the home banner. Only the newest
// request's answer is kept, so a slow older one can't overwrite newer data.
export function GetStartedProvider({ children }) {
  const location = useLocation();
  const [data, setData] = useState(null);
  const seq = useRef(0);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true; // set again on a StrictMode remount
    return () => { mounted.current = false; };
  }, []);

  const refresh = useCallback(async () => {
    const mine = ++seq.current;
    let res;
    try {
      res = await onboardingApi.get();
    } catch {
      return; // a helper is never worth an error
    }
    if (!mounted.current || mine !== seq.current) return;
    setData(res.data);
  }, []);

  useEffect(() => { refresh(); }, [refresh, location.pathname]);

  const value = useMemo(() => ({ data, refresh }), [data, refresh]);
  return <GetStartedContext.Provider value={value}>{children}</GetStartedContext.Provider>;
}

// { data, refresh }, or null outside a provider (feature off, not a club admin)
export const useGetStarted = () => useContext(GetStartedContext);
